module.exports = __webpack_public_path__ + "static/media/29180036-min.80d0c581.jpg";